import React from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const resolveUrl = (u) => (u && u.startsWith('/') ? `${BACKEND_URL}${u}` : u);

// Encaixe padrão: foto 58% da caixa, centralizada (moldura calibrada)
const DEFAULT_FIT = { x: 50, y: 50, size: 58 };

export const FramedAvatar = ({ src, frameUrl, size = 96, fit = null, alt = 'Avatar', className = '' }) => {
  if (!src) return null;
  const f = { ...DEFAULT_FIT, ...(fit || {}) };
  if (!frameUrl) {
    return (
      <img src={src} alt={alt} data-testid="user-avatar"
           className={`rounded-full border-4 border-white shadow object-cover ${className}`}
           style={{ width: size * 0.58 + 8, height: size * 0.58 + 8 }} />
    );
  }
  const photo = size * (f.size / 100);
  return (
    <div className={`relative flex-shrink-0 ${className}`} style={{ width: size, height: size }}
         data-testid="framed-avatar">
      <img src={src} alt={alt}
           className="absolute rounded-full object-cover"
           style={{
             width: photo, height: photo,
             left: `${f.x}%`, top: `${f.y}%`, transform: 'translate(-50%, -50%)',
           }} />
      <img src={resolveUrl(frameUrl)} alt=""
           className="absolute inset-0 w-full h-full pointer-events-none select-none"
           data-testid="avatar-frame" />
    </div>
  );
};

export default FramedAvatar;
